import { createFileRoute } from "@tanstack/react-router";
import AppLayout from "../../components/AppLayout";
import Footer from "../../components/Footer/Footer";
import { ThemeSlot } from "../../themes/slots";
import OrderTracking from "../../screens/OrderTracking";

export const Route = createFileRoute("/c/order-tracking/$orderId")({
  component: () => (
    <AppLayout>
      <ThemeSlot slot="header" />
      <RouteComponent />
      <Footer />
    </AppLayout>
  ),
});

function RouteComponent() {
  const { orderId } = Route.useParams();
  return (
    <>
      <OrderTracking orderId={orderId} />
    </>
  );
}
